<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form
        ref="storeForm"
        :model="formData"
        :rules="rules"
        label-width="140px"
        label-position="left"
        size="mini"
      >
        <p class="title">基本信息</p>
        <el-form-item label="门店名称" prop="storeName">
          <el-input v-model="formData.storeName" placeholder="请输入门店名称"></el-input>
        </el-form-item>
        <el-form-item label="所在外卖平台" prop="takeawayClient">
          <static-selector @update:value="handleChangeTakeawayClient" :value.sync="formData.takeawayClient" type="takeawayClient"></static-selector>
        </el-form-item>
        <el-form-item label="外卖平台门店名称" prop="takeawayStoreName">
          <el-input placeholder="请输入外卖平台门店名称" :disabled="formData.takeawayClient===0" v-model="formData.takeawayStoreName"></el-input>
        </el-form-item>
        <el-form-item label="外卖平台门店电话" prop="takeawayStorePhone">
          <el-input placeholder="请输入外卖平台门店电话" :disabled="formData.takeawayClient===0" v-model="formData.takeawayStorePhone"></el-input>
        </el-form-item>
        <el-form-item label="门店地址" prop="addressDetail">
          <cascader-address
            ref="cascader"
            :provinceId.sync="formData.provinceId"
            :provinceName.sync="formData.provinceName"
            :cityId.sync="formData.cityId"
            :cityName.sync="formData.cityName"
            :areaId.sync="formData.regionId"
            :areaName.sync="formData.regionName"
            :ywCityId.sync="formData.ywCityId"
            :text.sync="text"
            style="display: inline;"
          />
          <br />
          <el-input style="margin-top: 20px;" v-model="formData.address" placeholder="请输入门店地址信息"></el-input>
          <el-button class="marLeft10" @click="()=>{ $refs.map.search() }">定位</el-button>
        </el-form-item>
        <el-form-item label="定位地址" prop="address">
          <el-input
            :disabled="true"
            v-model="formData.addressDetail"
          ></el-input>
        </el-form-item>
        <map-address
          ref="map"
          style="margin-bottom: 10px"
          :keyword="`${text.join('')}${formData.address}`"
          @point="(info) => {  formData.address = info.title; formData.addressDetail = info.address; formData.lng= info.point.lng;formData.lat= info.point.lat  }"
        />
        <el-form-item label="联系人姓名" prop="personName">
          <el-input v-model="formData.personName" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="personPhone">
          <el-input v-model="formData.personPhone" placeholder="请输入联系人手机号"></el-input>
        </el-form-item>
        <el-form-item label="门店类型" prop="storeManagementType">
          <store-types
            :classA.sync="formData.classA"
            :classB.sync="formData.classB"
            :classC.sync="formData.classC"
            :classCNeed.sync="classCNeed"
            :classAName.sync="formData.classAName"
            :classBName.sync="formData.classBName"
            :classCName.sync="formData.classCName"
          ></store-types>
          <p
            v-if="$store.state.systemConfig.managementType.length> 1"
            style="color: red;display: inline;margin-left: 20px;"
          >暂无“客户类型”，请联系销售补充客户类型</p>
        </el-form-item>
        <el-form-item label="经营场所" prop="placeId">
          <static-selector :value.sync="formData.placeId" type="place" />
        </el-form-item>
        <el-form-item v-if="isShowTs" label="团膳经营类型" prop="tsId">
          <static-selector :value.sync="formData.tsId" type="tsType" />
        </el-form-item>
        <el-form-item label="门店图片" prop="storeImg">
          <p>门脸照（请上传一至三张图片）</p>
          <store-img-upload type="doorFacePic" @fileList="(data) => formData.doorFacePic= data"/>
          <p>注：门脸照需拍出完整门匾,门框,需在餐厅开门营业状态下完成拍摄(建议正对门店2米处拍摄) 。支持JPG, JPEG,PNG等格式大小不超过5M</p>
          <p>店内照（请上传一至三张图片）</p>
          <store-img-upload type="shopInPic" @fileList="(data) => formData.shopInPic= data"/>
          <p>注：店内照需真实反映用餐环境(收银台,用餐桌椅等)。支持JPG, JPEG,PNG等格式大小不超过5M</p>
        </el-form-item>
        <el-form-item label="营业执照" prop="licensePic">
          <store-img-upload :limit="1" type="licensePic" @fileList="(data) => formData.licensePic= data[0]"/>
          <p>注：用于门店开票审核，请准确填写，支持JPG, JPEG,PNG等格式大小不超过5M</p>
        </el-form-item>
        <el-form-item label="营业执照名称" prop="licenseName">
          <el-input v-model.trim="formData.licenseName" placeholder="请输入营业执照上的名称"></el-input>
        </el-form-item>
        <el-form-item label="注册号" prop="regNum">
          <el-input v-model.trim="formData.regNum" placeholder="请输入注册号（统一信用代码）"></el-input>
        </el-form-item>
        <el-form-item label="有效期" prop="expireType">
          <el-radio v-model="formData.expireType" :label="1">固定有效日期</el-radio>
          <el-date-picker
            v-model="formData.expireDate"
            :disabled="formData.expireType!== 1"
            v-if="formData.expireType=== 1"
            type="date"
            :picker-options="pickerOptions"
            :default-value="new Date()"
            style="margin-right: 20px;"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择日期" />
          <el-radio v-model="formData.expireType" :label="2">长久有效</el-radio>
        </el-form-item>
        <el-form-item label="楼层" prop="floor">
          <static-selector :value.sync="formData.floor" type="floor" />
        </el-form-item>
        <el-form-item label="电梯" prop="hasLift">
          <el-radio v-model="formData.hasLift" :label="1">有</el-radio>
          <el-radio v-model="formData.hasLift" :label="0">无</el-radio>
        </el-form-item>
        <p class="title">服务信息</p>
        <el-form-item label="收货时间" prop="receiveTime">
          <get-goods-time
            :receiveStartTime.sync="formData.receiveStartTime"
            :receiveEndTime.sync="formData.receiveEndTime"
            :text="timeText"
          />
        </el-form-item>
        <el-form-item label="门店备注">
          <el-input
            v-model="formData.desc"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请详细描述门店细节，例如门店是否有地下车库、如有是否限高；门店周围是否方便停车等"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="mini" @click="handleBack">取消</el-button>
        <el-button size="mini" type="primary" @click="onSubmit">保存并提交</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { callbackify } from "util";
export default {
  name: "store-message",
  data() {
    var checkRegNum = (rules, val, callback) => {
      if(!val) callback(new Error("请输入注册号"))
      else if(val.length> 20) callback(new Error("注册号不得超过20位"))
      callback()
    }
    var checkLisenceName = (rules, val, callback) => {
      if(!val) callback(new Error("请输入营业执照名称"))
      else if(val.length> 32) callback(new Error("营业执照名称不得超过32位"))
      callback()
    }
    var checkStoreName = (rules, val, callback) => {
      if (this.formData.storeName.length > 25)
        callback(new Error("门店名称不超过25字"));
      if (this.formData.storeName.length === 0)
        callback(new Error("门店名称不能为空"));
      callback();
    };
    var checkAddressDetail = (rules, val, callback) => {
      const { provinceId, cityId, addressDetail } = this.formData;
      if (provinceId && cityId && addressDetail) {
        callback();
      }
      callback(new Error(rules.message));
    };
    var checkReceiveTime = (rules, val, callback) => {
      const { receiveStartTime, receiveEndTime } = this.formData;
      if (receiveStartTime && receiveEndTime) {
        callback();
      }
      callback(new Error(rules.message));
    };
    var checkStoreManagement = (rules, val, callback) => {
      const { classA, classB, classC } = this.formData;
      if (this.classCNeed && classC.length === 0) {
        callback(new Error(rules.message));
      }
      if (!classA || !classB) {
        callback(new Error(rules.message));
      }
      callback();
    };
    var checkStoreImg= (rules, val, callback)=> {
      const {doorFacePic, shopInPic}= this.formData
      if((doorFacePic.length+ shopInPic.length)< 1) callback(new Error("门脸照，店内照两者至少上传一张"))
      callback()
    }
    var checkLicensePic=  (rules, val, callback)=> {
      const {licensePic}= this.formData
      if(licensePic === "") callback(new Error("请上传营业执照"))
      callback()
    }
    var checkExpireType= (rules, val, callback)=> {
      const {expireType, expireDate}= this.formData
      if(expireType=== 1 && !expireDate) callback(new Error("请选择固定有效日期"))
      callback()
    }
    var checkTsId= (rules, val, callback) => {
      if(val=== 0) callback(new Error(rules.message))
      callback()
    }
    return {
      formData: {
        storeName: "",
        classA: "",
        classB: "",
        classC: [],
        classCName: [],
        personName: "",
        personPhone: "",
        receiveStartTime: "",
        receiveEndTime: "",
        hasLift: 1,
        floor: "",
        ywCityId: "",
        address: "",
        addressDetail: "",
        lng: "",
        lat: "",
        placeId: "",
        branchMark: "",
        tsId: 0,
        title: "",
        provinceId: "",
        cityId: "",
        regionId: "",
        desc: "",
        doorFacePic: [],
        shopInPic: [],
        licensePic: '',
        licenseName: '',
        regNum: '',
        expireType: 1,
        expireDate: '',
        takeawayClient: 0,
        takeawayStoreName: '-',
        takeawayStorePhone: '-'
      },
      classCNeed: false,
      text: [],
      timeText: [],
      startTime: "",
      endTime: "",
      rules: {
        storeName: [
          {
            required: true,
            validator: checkStoreName
          }
        ],
        personName: [
          {
            required: true,
            message: "请输入联系人姓名"
          }
        ],
        personPhone: [
          {
            required: true,
            message: "请输入联系人电话"
          }
        ],
        receiveTime: [
          {
            validator: checkReceiveTime,
            required: true,
            message: "请填写送货时间"
          }
        ],
        storeManagementType: [
          {
            validator: checkStoreManagement,
            required: true,
            message: "请选择门店类型"
          }
        ],
        hasLift: [
          {
            required: true,
            message: "请选择是否有电梯"
          }
        ],
        floor: [
          {
            required: true,
            message: "请选择楼层"
          }
        ],
        address: [
          {
            required: true,
            message: "请填写详细地址"
          }
        ],
        addressDetail: [
          {
            validator: checkAddressDetail,
            required: true,
            message: "请填写门店地址信息"
          }
        ],
        placeId: [
          {
            required: true,
            message: "请选择经营场所"
          }
        ],
        tsId: [
          {
            required: true,
            validator: checkTsId,
            message: "请选择团膳经营类型"
          }
        ],
        storeManagementType: [
          {
            required: true,
            validator: checkStoreManagement,
            message: "请填写完整"
          }
        ],
        storeImg: [{required: true, validator: checkStoreImg}],
        licenseName: [{required: true, validator: checkLisenceName}],
        regNum: [{required: true, validator: checkRegNum}],
        expireType: [{required: true, validator: checkExpireType}],
        licensePic: [{required: true, validator: checkLicensePic}]
      },
      isShowTs: false,
      pickerOptions: {
        disabledDate: (time) => {
          const now = new Date()
          const year = now.getFullYear()
          const month = now.getMonth()
          const day = now.getDate()-1
          return time.getTime() < new Date(year, month, day, 23, 59, 59).getTime()
        }
      },
    };
  },
  watch: {
    storeManagementType: function(val) {
      const [classB, classC] = val;
      Object.assign(this.formData, { classB, classC });
    }
  },
  created() {
    this.getIsShowTs();
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    async getIsShowTs() {
      const { ret, data } = await _api.store.isShowTs();
      if (ret && data) {
        this.isShowTs = data;
        this.formData.tsId = this.isShowTs ? "" : 0;
      }
    },
    onSubmit() {
      console.log(this.formData);
      const { takeawayClient, takeawayStoreName, takeawayStorePhone } = this.formData;
      if(takeawayClient !== 0) {
        if(!takeawayStoreName) {
          return this.$message.error("请输入外卖平台门店名称")
        }
        if(!takeawayStorePhone) {
          return this.$message.error("请输入外卖平台门店电话")
        }
      }
      this.$refs["storeForm"].validate(val => {
        if (val) {
          this.save();
        } else {
          this.$message({
            type: "warning",
            message: "请完成信息后提交"
          });
        }
      });
    },
    async save() {
      if(this.formData.expireType=== 2) this.formData.expireDate= new Date().getTime()
      this.formData.expireDate/= 1000
      const {
        ret,
        data: { applyId }
      } = await _api.store.storeCreate(this.formData);
      if (ret && applyId) {
        // this.$confirm(
        //   "门店提交成功，请等待审核结果，现在需要给门店关联人员账号吗？",
        //   "提示",
        //   {
        //     confirmButtonText: "马上关联",
        //     cancelButtonText: "取消",
        //     type: "success"
        //   }
        // )
        //   .then(() => {
        //     this.goToAddPersonnel(storeId);
        //   })
        //   .catch(() => {
        //     this.handleBack();
        //   });
        this.$message({
            type: "success",
            message: "门店提交成功，请等待审核结果，可在待审核门店页面查看进展"
          });
        this.handleBack();
      }
      this.formData.expireDate= ""
    },
    goToAddPersonnel(storeId) {
      this.$router.push({
        path: "/storeManagement/add/addPersonnel",
        query: {
          storeId
        }
      });
    },
    handleChangeTakeawayClient(value) {
      const { takeawayClient, takeawayStoreName, takeawayStorePhone } = this.formData || {};
      if(value === 0) {
        this.formData.takeawayStoreName = '-';
        this.formData.takeawayStorePhone = '-';
      } else if(value !== 0 && takeawayStoreName === '-' && takeawayStorePhone === '-') {
        this.formData.takeawayStoreName = '';
        this.formData.takeawayStorePhone = '';
      }
    }
  }
};
</script>
<style scoped>
.el-input {
  width: 300px;
}
.el-textarea {
  width: 400px;
}
.el-select {
  width: 130px;
}
.title {
  font-weight: 900;
  font-size: 18px;
}
</style>
